import React from 'react';
import ReactDOM from 'react-dom';

import './assets/bootstrap/css/bootstrap.min.css'
import './assets/bootstrap/css/bootstrap-theme.css'
import './assets/bootstrap/css/bootstrap-theme.css.map'
import './assets/bootstrap/css/bootstrap.css'

import './assets/css/style.css'
import './assets/css/animate.css'
import './assets/css/media-queries.css'
import './assets/css/form-elements.css'
import './index.css';

import App from './App';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


